var _a;
import React from 'react';
import styled from 'styled-components';
import SectionHeader from '../SectionHeader';
import { textWithLinks } from '../../helpers';
import { isAllInputsValid } from '../../utils';
import { Tick } from '../Icons';
import { theme } from '../../styled';
const cautionIcon = (_a = require('../Input/svg/icon_caution.svg')) === null || _a === void 0 ? void 0 : _a.default;
export const TermsAndConditionsWrapper = styled.div `
  color: ${(props) => props.theme.fontColor};
  background-color: ${(props) => props.theme.background};
  margin: 16px 0;
  .SectionHeader {
    margin-bottom: 10px;
  }
  .col-12 {
    ${(props) => props.showHighLight &&
    `
      background-color: #fefaf2;
      box-shadow: 0 -9px 0 0 rgba(254,250,242,1);
      -webkit-box-shadow: 0 -9px 0 0 rgba(254,250,242,1);
      -moz-box-shadow: 0 -9px 0 0 rgba(254,250,242,1);
     `}
  }
  .item {
    display: flex;
    margin: 0;
    border-radius: 4px;
  }
  .name {
    display: flex;
    margin-bottom: 1rem;
  }
  .term-text {
    font-size: ${(props) => props.theme.fontXSmall};
  }
  .required {
    color: ${(props) => props.theme.required};
  }
  input {
    margin: 5px;
  }
  .error {
    color: ${(props) => props.theme.required};
    padding: 8px;
  }
  .icon {
    width: 16px;
    height: 16px;
    margin-right: 5px;
  }
  .invalid {
    border: 1px solid ${(props) => props.theme.required};
    padding: 8px;
  }
  .active {
    cursor: pointer;
  }

  input {
    position: absolute;
    left: -9999px;
  }

  label {
    position: relative;
    padding-left: 1.85em;
    line-height: 1.313rem;
    font-size: ${(props) => props.theme.fontSmall};
    color: ${(props) => props.theme.fontColor};
  }

  .tickBox {
    position: absolute;
    left: 0;
    top: 0.22em;
    width: 1.15em;
    height: 1.15em;
    border: 2px solid #ccc;
    background: #fff;
    border-radius: 4px;
    box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.1);
  }

  .tickIcon {
    position: absolute;
    top: -2px;
    left: 1px;
    transition: all 0.2s;
    opacity: 0;
    transform: scale(0);
    fill: ${(props) => props.theme.tickColor};
  }

  input:checked + label .tickIcon {
    opacity: 1;
    transform: scale(1);
  }

  input:disabled + label {
    color: ${(props) => props.theme.fontColor};

    .tickBox {
      box-shadow: none;
      border: none;
      background: none;
    }
  }

  input:focus + label .tickBox {
    border: 2px solid ${theme.lightBlue};
  }
`;
const AdditionalTermsInfoWrapper = styled.div `
  color: ${(props) => props.theme.fontColor};
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
  padding: 10px 15px 0 15px;
`;
const TermsAndConditions = ({ header, items, onClick, showHighLight, disabled, scrollRef, type, additionalTermsInfo, }) => {
    const inputsState = [];
    const termsAndConditionsBox = items.map((item, i) => {
        inputsState.push(item.preSelected);
        return (React.createElement("div", { key: i, className: "col-12" },
            React.createElement("div", { className: `item ${item.state || ''}`, id: item.id },
                React.createElement("input", { type: "checkbox", id: item.id, checked: item.preSelected, disabled: !item.active || disabled, onChange: () => !item.active && onClick(item.id) }),
                React.createElement("label", { className: `name ${item.active ? 'active' : ''} `, htmlFor: item.id, onClick: () => item.active && !disabled && onClick(item.id), id: "sign-terms_and_conditions-input", "data-testid": "terms-and-conditions" },
                    React.createElement("div", { className: "tickBox", "data-testid": "terms-and-conditions-tick-box" },
                        React.createElement(Tick, { color: type === 'v81' ? '#008000' : '', className: "tickIcon" })),
                    React.createElement("div", { className: "term-text" },
                        item.required && React.createElement("span", { className: "required" }, "* "),
                        textWithLinks(item.body))),
                item.state === 'invalid' && (React.createElement("div", { className: "error" },
                    React.createElement("img", { src: cautionIcon, alt: "error", className: "icon" }),
                    item.error)))));
    });
    return (React.createElement("div", { ref: scrollRef },
        header && React.createElement(SectionHeader, { text: header }),
        additionalTermsInfo && (React.createElement(AdditionalTermsInfoWrapper, null, additionalTermsInfo)),
        React.createElement(TermsAndConditionsWrapper, { showHighLight: showHighLight && !isAllInputsValid(inputsState) }, termsAndConditionsBox)));
};
TermsAndConditions.defaultProps = { showHighLight: false };
export default TermsAndConditions;
